module.exports = __webpack_public_path__ + "img/jiejing2.637abc70.png";